module.exports = __webpack_public_path__ + "static/media/manage-user.dd131972.svg";